module.exports = __webpack_public_path__ + "img-questionnaire.6bd7125fa99d7087f826f945845a2a68.hashedasset.svg";